import { FC } from "react"
import * as React from "react"
import cx from "classnames"

import * as styles from "./styles.module.scss"
import LinkUnderline from "../../LinkUnderline"
import MediaPlayButton from "../../MediaPlayButton"

export interface QuestionVideoProps {
  embedUrl: string
  poster: string
  title: string
}

const QuestionVideo: FC<QuestionVideoProps> = ({ title, poster, embedUrl }) => {
  return (
    <section className={styles.questionVideo}>
      <a
        className={cx({
          [styles.link]: true,
          ["js-modal-video"]: true,
        })}
        href={embedUrl}
      >
        <figure className={styles.poster}>
          <img className={styles.image} src={poster} alt={title} />
          <div className={styles.play}>
            <MediaPlayButton className={styles.mediaPlayButton} />
          </div>
        </figure>
        <h3 className={styles.heading}>
          <LinkUnderline>{title}</LinkUnderline>
        </h3>
      </a>
    </section>
  )
}

export default QuestionVideo
